var ResgionService = function () {
  var regions = []
  var regionsByRegionId = {}

  return {
    getRegions: function () {
      return regions
    },
    getRegionByRegionId: function (regionId) {
      return regionsByRegionId[regionId]
    },
    /* getRegionsByName: function () {
        return regions.slice().sort(function (a, b) {
            return (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0);
        });
    }, */
    setRegions: function (_regions) {
      regionsByRegionId = {}
      regions = _regions
      regions.forEach(function (region) {
        // Hash by Id
        regionsByRegionId[region.RegionId] = region
      })

      // $rootScope.$broadcast('setRegions', regions);
    },
    updateRegion: function (_region) {
      // var region = regionsByRegionId[_region.RegionId]
      // TO DO !update children maybe?
      // $rootScope.$broadcast('updateRegion', region);
    }
  }
}

export default new ResgionService()



// WEBPACK FOOTER //
// ./src/services/RegionService.js